import { SettingsManager } from "@viamap/viamap2-common";
import jsPDF from "jspdf";
import { PromiseImage } from "src/functions/PaperCanvas";
import { utils, writeFile } from "xlsx";

/**
 * Stable split into parts function that tries to avoid having a very small last part. It will try to balance the last two parts if the last part is too small. The fn parameter is used to determine the length of the part, and can be used to count items in a nested structure.
 */
export function splitIntoPartsStable<T>(arr: T[], maxLength: number, fn: (arr: T[]) => number): T[][] {
   let part = [arr];
   let i = 0;
   let parIdx = 0;
   if (fn(arr) >= maxLength) {
      part = [[]];
      while (i < arr.length) {
         if (fn([...part[parIdx], arr[i]]) >= maxLength) {
            parIdx++;
            part.push([]);
         }
         part[parIdx].push(arr[i]);
         i++;
      }
      if (parIdx <= 0) return part;
      let minLength = Math.min(3, Math.floor(part[parIdx - 1].length / 2)) - part[parIdx].length;
      console.log("part", part);
      if (minLength > 0) {
         part[parIdx] = [...part[parIdx - 1].splice(-minLength), ...part[parIdx]];
      }
   }
   return part;
}

export function makeAsTableData<T>(arr: T[], fn: (item: object, mainObj: T) => object | undefined, path?: string): any[] {
   if (path) {
      const pathParts = path.split(".");
      return arr.map(item => {
         const mainObj = pathParts.reduce((obj, key) => obj[key], item);
         if (!Array.isArray(mainObj)) {
            console.error("Expected an array at the end of the path, but got:", mainObj);
            return [];
         }
         return mainObj.map((subItem: any) => {
            if (typeof subItem !== "object" || subItem === null) {
               console.error("Expected an object, but got:", subItem);
               return {};
            }
            return fn(subItem, item)
         }) || [];
      }).flat();
   }
   return arr.map(item => {
      if (typeof item !== "object" || item === null) {
         console.error("Expected an object, but got:", item);
         return {};
      }
      return fn(item, item) || {};
   });
}

export function tableToExcel(data: unknown[], filename: string) {
   const worksheet = utils.json_to_sheet(data);
   const workbook = utils.book_new();
   utils.book_append_sheet(workbook, worksheet, "Sheet 1");
   writeFile(workbook, filename);
}

export function aktIdFormat(aktId: string) {
   return aktId.replace(/(.{4})(.{2})(.{2})-()/, "$3.$2.$1-$4")
}

export async function addDatarapportImage(page: jsPDF, top: number) {
   if (SettingsManager.getSystemSetting("datarapportImageDisabled", false)) return top;
   let imgUrl = SettingsManager.getSystemSetting("datarapportImageUrl", "") || "";
   if (!imgUrl) return;
   let imgLink = SettingsManager.getSystemSetting("datarapportImageLink", "") || "";
   let img = await PromiseImage(imgUrl).then((img) => {
      if (!img) {
         console.error("Failed to load datarapport image");
         return { height: 0 };
      };
      const imgProps = page.getImageProperties(img);
      const pageWidth = page.internal.pageSize.getWidth();
      const pageHeight = page.internal.pageSize.getHeight();
      const imgWidth = (pageWidth * 0.5) - 30;
      const imgHeight = (imgProps.height / imgProps.width) * imgWidth;
      const x = (pageWidth - imgWidth) - 15;
      const y = top + 10;
      const imageCanvas = document.createElement("canvas");
      const imageContext = imageCanvas.getContext("2d");
      imageCanvas.width = img.naturalWidth || img.width;
      imageCanvas.height = img.naturalHeight || img.height;
      if (!imageContext) return { height: 0 };
      imageContext.fillStyle = "#fff";
      imageContext.fillRect(0, 0, imageCanvas.width, imageCanvas.height);
      imageContext.drawImage(img, 0, 0);
      const imageData = imageCanvas.toDataURL("image/png");
      if (y + imgHeight > page.internal.pageSize.getHeight()) {
         page.addPage();
      }
      page.addImage(imageData, "PNG", x, pageHeight - imgHeight - 15, imgWidth, imgHeight);
      if (imgLink) {
         page.link(x, pageHeight - imgHeight - 15, imgWidth, imgHeight, { url: imgLink });
      }
      return img;
   }).catch(err => {
      console.error("Error loading datarapport image", err);
      return { height: 0 };
   });
   return top + img.height + 10;
}